import PropTypes from 'prop-types';
import React, { lazy } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import CompanyEdit from './Components/CompanyEdit';
import InsuranceCompanyWrapper from './Components/InsuranceCompanyWrapper';

const layout = window.$environment?.CURRENT_LAYOUT;
const Message = lazy(() => import(`globalcomponents/UI/Message/${layout}`));
const Button = lazy(() => import(`globalcomponents/UI/Button/${layout}`));
const FormStyle = require(`globalcomponents/UI/Form/${layout}/serverStyle`).default;

const RenderComponent = ({
  values,
  handleEdit,
  errors,
  isNotValid,
  validateForm,
  customProps: {
    i18n,
    Styled,
    hasSaveApiStatus,
    states,
    underWriters,
    lossControllers,
    type,
    allCycleRules,
    allCycleExceptions,
    allVehicleTypes,
  },
  submitAction,
  cancelAction,
}) => {
  const showError = (field, validationErrors, isNotValid, apiError) => {
    if (validationErrors[field] && !isNotValid) {
      return <Message type="error" message={errors[field]} />;
    }
    if (apiError?.[field]) {
      return <Message type="error" message={apiError[field]} />;
    }
  };
  const dotUpdation = (value) => {
    return value.substring(0, 9);
  };

  return (
    <Styled.Wrapper>
      {type === 'edit' && (
        <CompanyEdit
          {...{
            Styled,
            values,
            handleEdit,
            showError,
            errors,
            isNotValid,
            hasSaveApiStatus,
            dotUpdation,
            type,
            states,
          }}
        />
      )}

      <InsuranceCompanyWrapper
        {...{
          Styled,
          values,
          handleEdit,
          showError,
          errors,
          isNotValid,
          hasSaveApiStatus,
          dotUpdation,
          type,
          states,
          allVehicleTypes,
          allCycleRules,
          allCycleExceptions,
          lossControllers,
          underWriters,
        }}
      />

      {hasSaveApiStatus?.errorMessage && <Message type="error" message={hasSaveApiStatus.errorMessage} />}
      <div className="buttonSection">
        <FormStyle.ButtonsWrapper className="submitSection">
          <Button
            className="buttonStyle"
            type="reset"
            label={i18n.t('common.cancel')}
            onClick={(e) => {
              cancelAction();
            }}
          />
          <Button
            id="companyInfoSubmit"
            type="submit"
            label={hasSaveApiStatus?.isLoading ? <CircularProgress color="inherit" /> : i18n.t('Save')}
            onClick={() => {
              const validateResponse = validateForm();
              validateResponse.then((data) => submitAction(data));
            }}
          />
        </FormStyle.ButtonsWrapper>
      </div>
    </Styled.Wrapper>
  );
};

export default RenderComponent;

RenderComponent.propTypes = {
  values: PropTypes.object.isRequired,
  handleEdit: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  isNotValid: PropTypes.bool.isRequired,
  customProps: PropTypes.object.isRequired,
  validateForm: PropTypes.func.isRequired,
  submitAction: PropTypes.func.isRequired,
};
